/**
 * Creates the fallback placements when auto flip is enabled.
 * If alignment !== 'center', then we'll add the proper alignment placements so the flip will try those positions first to maintain alignment preference.
 * @see {@link Placement}
 */
export var getPopperFlipPositions = function getPopperFlipPositions() {
  var autoFlip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var align = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!autoFlip) {
    return [];
  }
  return align !== 'center' ? ["top-".concat(align), "bottom-".concat(align), 'top', 'bottom'] : ['top', 'bottom'];
};